<template>
  <div>
    <swiper
      ref="swiper"
      class="swiper swiper-applecare"
      :options="swiperOption"
    >
      <swiper-slide
        v-for="(item, index) in data"
        :key="item.sku || index"
      >
        <AppleCareCard
          :data="item"
          :select="isSelected(item)"
          @click="onSelect(item)"
          @learn-more="openLearnMore"
        />
      </swiper-slide>
      <!-- 
      <div class="swiper-button-prev" slot="button-prev">
        <span class="angle-icon">
          <v-icon color="white">
            mdi-chevron-left
          </v-icon>
        </span>
      </div>
      <div class="swiper-button-next" slot="button-next">
        <span class="angle-icon">
          <v-icon color="white">
            mdi-chevron-right
          </v-icon>
        </span>
      </div> -->
    </swiper>

    <div class="swiper-pagination swiper-pagination-applecare"></div>

    <PDPModalAppleCareInfo
      ref="learnMoreModal"
      :htmlContent="activeHtml"
    />
  </div>
</template>

<script>
import AppleCareCard from '@/components/bnn/AppleCareCard'

export default {
  components: {
    AppleCareCard,
    PDPModalAppleCareInfo: () =>
      import('@/components/studio7/PDPModalAppleCareInfo.vue'),
  },

  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      activeHtml: '',
      swiperOption: {
        preventClicksPropagation: false,
        spaceBetween: 12,
        slidesPerView: 1.12,
        slidesPerGroup: 1,
        watchOverflow: true,
        pagination: {
          el: '.swiper-pagination-applecare',
          clickable: true,
        },
        // If you want to enable navigation buttons, uncomment the following section
        // navigation: {
        //   enabled: false,
        //   nextEl: '.swiper-button-next',
        //   prevEl: '.swiper-button-prev',
        // },
        breakpoints: {
          // Define breakpoints for responsive design
        },
      },
    }
  },

  computed: {
    swiper() {
      return this.$refs.swiper.swiper
    },
  },

  watch: {
    data() {
      this.$nextTick(() => {
        this.$refs.swiper?.$swiper?.update()
      })
    },
  },

  mounted() {
    this.$nextTick(() => {
      this.$refs.swiper.$swiper.update()
    })
  },

  methods: {
    isSelected(item) {
      return this.$store.getters['bundle/countBySKU'](item) > 0
    },

    onSelect(item) {
      const wasSelected = this.isSelected(item)
      const replacing = this.data.find(
        w =>
          w.sku !== item.sku &&
          this.$store.getters['bundle/countBySKU'](w) > 0,
      )

      // store's warranty-aware toggle clears the sibling warranty
      this.$store.dispatch('bundle/toggle', item)

      if (!wasSelected && replacing) {
        this.$toast.clear()

        this.$toast.success(
          `เปลี่ยนความคุ้มครองเป็น “${item.name}” แล้ว`,
          {
            position: 'top',
            duration: 3000,
          },
        )
      }

      this.$emit('change', item)
      this.$forceUpdate()
    },

    openLearnMore(item) {
      this.activeHtml = item.description
      this.$refs.learnMoreModal.openModal()
    },
  },
}
</script>

<style lang="stylus" scoped>

.swiper-applecare {
    background white
}

.swiper-pagination {
    position: static !important;
    display: flex;
    justify-content: center;
    grid-gap: 1rem;
    gap: 1rem;
    margin-top: 0.5rem;
    padding: .5rem 0;
}

::v-deep {
    .swiper-pagination-bullet {
        width: 12px !important;
        height: 12px !important;
        opacity: 1 !important;
        background-color: #d0d0d0 !important;
        border-radius: 50% !important;
        transition: width .3s, background-color .3s;
    }

    .swiper-pagination-bullet-active {
        background-color: #969696 !important;
    }
}

.angle-icon {
    width: 28px
    height: 48px
    background: $color-bnn-gray-medium-2
    border-radius: 6px
    display: flex
    justify-content: center
    align-items: center
}

.swiper {
  height: fit-content;
  width: 100%;

  .swiper-slide {
    height: auto
    display: flex
    flex-direction: column
    position: relative
    text-align: left
    background: none
  }
}

.swiper-button-prev, .swiper-rtl .swiper-button-next {
  left 0 !important
  position : absolute
}

.swiper-button-next, .swiper-rtl .swiper-button-prev {
  right 0 !important
}

.swiper-button-next::after, .swiper-button-prev::after {
    content: "" !important
}

.swiper-button-next, .swiper-button-prev {
    color: white !important
    width auto !important
}

.swiper-button-prev,
.swiper-button-next
	cursor: pointer
	z-index: 100
	transition: 0.2s ease-in-out !important
.swiper-button-prev.swiper-button-disabled,
.swiper-button-next.swiper-button-disabled
	display: none !important
	transition: 0.2s ease-in-out !important
</style>
